export default __webpack_public_path__ + "static/media/faq.02bd8134.md";